module.exports = __webpack_public_path__ + "img/chadle_adv_22.18dda80f.png";